import { z } from 'zod';
import type { IpgBrowserTokenizationSession } from '../../types/ipg/ipg-browser-tokenization-session-registry';
import { CardPointeCardSecureBrowserTokenizationSessionSchema } from './cardpointe/cardpointe-tokenization.schemas';
import { CloverEcommerceBrowserTokenizationSessionSchema } from './clover/clover-tokenization.schemas';
import { ValorBrowserTokenizationSessionSchema } from './valor/valor-payment.schemas';

export const IpgBrowserTokenizationSessionSchema: z.ZodType<IpgBrowserTokenizationSession> =
    z.union([
        ValorBrowserTokenizationSessionSchema,
        CardPointeCardSecureBrowserTokenizationSessionSchema,
        CloverEcommerceBrowserTokenizationSessionSchema,
    ]);
